/**
 * Computes the smallest replacement range that turns `oldValue` into `newValue`,
 * trimming the common prefix and suffix so unaffected regions stay untouched.
 */
export function computeMinimalChange(
  oldValue: string,
  newValue: string,
): {
  from: number;
  to: number;
  insert: string;
} {
  let from = 0;

  // Trim common prefix
  while (
    from < oldValue.length &&
    from < newValue.length &&
    oldValue[from] === newValue[from]
  ) {
    from++;
  }

  let to = oldValue.length;
  let newEnd = newValue.length;
  // Trim common suffix
  while (
    to > from &&
    newEnd > from &&
    oldValue[to - 1] === newValue[newEnd - 1]
  ) {
    to--;
    newEnd--;
  }

  return { from, to, insert: newValue.slice(from, newEnd) };
}
